var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_3455)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 22,
    fill: "#025AB8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 23,
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9949 31.0012L23.8814 33.992L19.8281 32.1314L18.9961 33.9618L21.7622 35.2315L20.2407 36.1214L21.231 37.859L22.7523 36.9693L22.4547 40.0305L24.4354 40.2156L24.8715 35.7298L29.9873 32.7376V38.7528L26.3674 41.3801L27.5422 42.9988L29.9873 41.2241V43H31.9873V41.224L34.4326 42.9988L35.6074 41.3801L31.9873 38.7527V32.7514L37.1146 35.7503L37.5507 40.2367L39.5314 40.0515L39.2338 36.9898L40.7554 37.8798L41.7457 36.1422L40.2243 35.2523L42.99 33.9828L42.158 32.1525L38.1051 34.0128L32.956 31.0012L38.0893 27.9988L42.1689 29.8715L43.0009 28.0412L40.2085 26.7593L41.7477 25.859L40.7574 24.1214L39.2476 25.0045L39.5423 21.9725L37.5616 21.7873L37.1284 26.244L31.9873 29.251V23.2675L35.6306 20.6233L34.4559 19.0047L31.9873 20.7963V19H29.9873V20.7625L27.5654 19.0047L26.3907 20.6233L29.9873 23.2337V29.2648L24.8872 26.2818L24.4483 21.7665L22.4676 21.9517L22.768 25.0423L21.229 24.1422L20.2387 25.8798L21.7485 26.7628L19.0089 28.0204L19.841 29.8507L23.8677 28.0023L28.9949 31.0012Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_3455",
    x: 0.421053,
    y: 0.421053,
    width: 61.1579,
    height: 61.1579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.28947
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.53849 0 0 0 0 0.567513 0 0 0 0 0.6125 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3455",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.68b5a8874e876e1f0136a44690336260.svg";
export { ForwardRef as ReactComponent };